const Day_10 = [
    {id: "1", value: "1天"},    
    {id: "2", value: "2天"},
    {id: "3", value: "3天"},
    {id: "4", value: "4天"},
    {id: "5", value: "5天"},
    {id: "6", value: "6天"},
    {id: "7", value: "7天"},
    {id: "8", value: "8天"},
    {id: "9", value: "9天"},
    {id: "10", value: "10天"},
    {id: "15", value: "15天"},    
    {id: "20", value: "20天"},
    {id: "25", value: "25天"},    
    {id: "30", value: "30天"},
    {id: "35", value: "35天"},    
    {id: "40", value: "40天"}    
  ];  
  
  export default Day_10  